const messages = {
  en: {
    message: {
      pageHeader: {
        about: 'About',
        pricing: 'Pricing',
        register: 'Register',
        shopifySignin: 'sign in with Shopify',
        contactSupport: 'mailto:nicolas@anagraph.io?Subject=Geometric%20support',
        login: 'Log in',
        logout: 'Log out',
        help: 'Help'
      },
      sync: {
        caching: 'data synchronisation ...',
        importing: 'geocoding customers ...',
        geocodeWait: 'please wait, this could take one or two minutes.',
        limit: 'You have reached the maximum number of geocoded customers. Please contact us to learn more',
        popOut: 'click to continue'
      },
      customerPanel: {
        totalCustomers: 'Customers',
        totalOrders: 'Orders',
        totalSpent: 'Sales'
      },
      shopifyLogin: {
        title: 'Enter your store name',
        button: 'Sign in'
      },
      errorMessages: {
        generic: 'Something went wrong, please try again later'
      },
      creditLimitReached: {
        generic: 'You have reached your geocoding credit limit, please contact us if you\'d like to customize your experience'
      }
    }
  },
  fr: {
    message: {
      pageHeader: {
        about: 'À propos',
        pricing: 'Prix',
        register: 'Inscription',
        shopifySignin: 'se connecter avec Shopify',
        contactSupport: 'mailto:nicolas@anagraph.io?Subject=Support%20Geometric',
        login: 'Connexion',
        logout: 'Déconnexion',
        help: 'Aide'
      },
      sync: {
        caching: 'synchronisation des données ...',
        importing: 'géolocalisation des clients ...',
        geocodeWait: 'veuillez  patienter, cela peut prendre une ou deux minutes.',
        limit: 'Vous avez atteint le nombre maximum de clients géocodés. veuillez nous contacter pour en savoir plus',
        popOut: 'cliquez pour continuer'
      },
      customerPanel: {
        totalCustomers: 'Clients',
        totalOrders: 'Commandes',
        totalSpent: 'Ventes'
      },
      shopifyLogin: {
        title: 'Entrez le nom de votre boutique',
        button: 'Connexion'
      },
      errorMessages: {
        generic: 'Quelque chose a mal tourné, veuillez réessayer plus tard'
      },
      creditLimitReached: {
        generic: 'Vous avez atteint votre limite de crédit de géocodage, veuillez nous contacter si vous souhaitez personnaliser votre expérience'
      }
    }
  }
}
export default messages
